import {
  SELECT_PRODUCT_ID,
  SELECT_PB_ID,
  SELECT_BILL_ID,
  SELECT_UNIT,
  SELECT_VERBIAGE,
  SELECT_TEMP_ACTIVE_PRODUCT_ID,
  SELECT_PRODUCT,
  SELECT_BILL,
} from './Types';

const AppReducer = (state, action) => {
  switch (action.type) {
    case SELECT_PRODUCT_ID:
      return {
        ...state,
        productId: action.payload,
      };
    case SELECT_PB_ID:
      return {
        ...state,
        pbId: action.payload,
      };
    case SELECT_BILL_ID:
      return {
        ...state,
        billId: action.payload,
      };
    case SELECT_UNIT:
      return {
        ...state,
        unit: action.payload,
      };
    case SELECT_VERBIAGE:
      return {
        ...state,
        verbiage: action.payload,
      };
    case SELECT_TEMP_ACTIVE_PRODUCT_ID:
      return {
        ...state,
        tempActiveProductId: action.payload,
      };
    case SELECT_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
      };
    case SELECT_BILL:
      return {
        ...state,
        selectedBill: action.payload,
      };
    default:
      return state;
  }
};

export default AppReducer;
